/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PatchApiV1ExamRevisionLangBotexamlangidActive202,
  PatchApiV1ExamRevisionLangBotexamlangidActive400,
  PatchApiV1ExamRevisionLangBotexamlangidActive401,
  PatchApiV1ExamRevisionLangBotexamlangidActive404,
  PatchApiV1ExamRevisionLangBotexamlangidActive500,
  PatchApiV1ExamRevisionLangBotexamlangidActiveMutationResponse,
  PatchApiV1ExamRevisionLangBotexamlangidActivePathParams,
} from "../../types/examRevisionController/PatchApiV1ExamRevisionLangBotexamlangidActive.ts";

export const patchApiV1ExamRevisionLangBotexamlangidActivePathParamsSchema =
  z.object({
    botExamLangId: z.coerce.number().int(),
    active: z.boolean(),
  }) as unknown as ToZod<PatchApiV1ExamRevisionLangBotexamlangidActivePathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const patchApiV1ExamRevisionLangBotexamlangidActive202Schema =
  z.any() as unknown as ToZod<PatchApiV1ExamRevisionLangBotexamlangidActive202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const patchApiV1ExamRevisionLangBotexamlangidActive400Schema =
  z.any() as unknown as ToZod<PatchApiV1ExamRevisionLangBotexamlangidActive400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const patchApiV1ExamRevisionLangBotexamlangidActive401Schema =
  z.any() as unknown as ToZod<PatchApiV1ExamRevisionLangBotexamlangidActive401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const patchApiV1ExamRevisionLangBotexamlangidActive404Schema =
  z.any() as unknown as ToZod<PatchApiV1ExamRevisionLangBotexamlangidActive404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const patchApiV1ExamRevisionLangBotexamlangidActive500Schema =
  z.any() as unknown as ToZod<PatchApiV1ExamRevisionLangBotexamlangidActive500>;

export const patchApiV1ExamRevisionLangBotexamlangidActiveMutationResponseSchema =
  z.lazy(
    () => patchApiV1ExamRevisionLangBotexamlangidActive202Schema,
  ) as unknown as ToZod<PatchApiV1ExamRevisionLangBotexamlangidActiveMutationResponse>;
